import { NgModule } from '@angular/core';
import { MyFlexLayoutDirective } from './my-flex-layout.directive';

@NgModule({
    imports: [MyFlexLayoutDirective],
    exports: [MyFlexLayoutDirective]
})
export class FlexLayoutDirectiveModule { }
